

import { Button } from '@/components/ui/button';

export interface ShowAllButtonProps {
  totalCount: number;
  displayedCount: number;
  showingAll: boolean;
  onShowAll: () => void;
  onShowLess: () => void;
}

export function ShowAllButton({ 
  totalCount, 
  displayedCount, 
  showingAll, 
  onShowAll, 
  onShowLess 
}: ShowAllButtonProps) {
  if (totalCount <= displayedCount && !showingAll) {
    return null;
  }
  
  return (
    <div className="flex justify-center">
      {showingAll ? (
        <Button 
          variant="outline" 
          onClick={onShowLess}
        >
          Show Less
        </Button>
      ) : (
        <Button 
          variant="outline" 
          onClick={onShowAll}
        >
          Show All ({totalCount})
        </Button>
      )}
    </div>
  );
}
